import {
  ACCEPT_LOAN,
  APPROVED,
  JOINT_APPLICATION,
  REFERRED,
  SUBMITTED,
  instantApprovalProducts,
  productIds,
} from '../../utils';
import { ApplicationSubmissionStatus, StatusStep, StepType, Steps } from './types';

export const getInitialSteps = (
  isJointForm: boolean,
  hasJoint: boolean,
  status?: ApplicationSubmissionStatus,
): Steps => {
  if (status === ApplicationSubmissionStatus.APPROVED) {
    return [
      {
        title: APPROVED.TITLE,
        completed: APPROVED.COMPLETED,
        key: StatusStep.APPROVED,
      },
    ];
  }

  return [
    {
      title: isJointForm || hasJoint ? SUBMITTED.TITLE_JOINT : SUBMITTED.TITLE,
      key: StatusStep.SUBMITTED,
    },
  ];
};

export const getStatusSteps = ({
  isJointForm,
  financialProductId,
  jointApplicantName,
  applicationStatus,
  isCashApplication,
}: {
  isJointForm: boolean;
  financialProductId: string;
  jointApplicantName?: string;
  applicationStatus?: ApplicationSubmissionStatus;
  isCashApplication?: boolean;
}): Steps => {
  const hasJointOrIsJoint = !!jointApplicantName || isJointForm;
  const isBrightePay = financialProductId === productIds.BRIGHTE_PAY;

  const steps: Steps = [];

  const hideJointStep = isBrightePay
    ? applicationStatus === ApplicationSubmissionStatus.APPROVED
    : applicationStatus === ApplicationSubmissionStatus.APPROVED ||
      applicationStatus === ApplicationSubmissionStatus.REFERRED;

  if (hasJointOrIsJoint && !hideJointStep) {
    steps.push({
      title: isJointForm ? JOINT_APPLICATION.SUBMITTED_TITLE : JOINT_APPLICATION.TITLE,
      content: isBrightePay
        ? JOINT_APPLICATION.JOINT_APPLICATION_PENDING
        : JOINT_APPLICATION.description(jointApplicantName),
      key: StatusStep.JOINT_APPLICATION,
    });
  }

  if (applicationStatus === ApplicationSubmissionStatus.REFERRED) {
    steps.push({
      title: REFERRED.TITLE,
      content: REFERRED.CONTENT,
      key: StatusStep.UNDER_REVIEW,
    });
  }

  if (!instantApprovalProducts.includes(financialProductId) && !isCashApplication) {
    const text = hasJointOrIsJoint ? ACCEPT_LOAN.JOINT_DESCRIPTION : ACCEPT_LOAN.DESCRIPTION;
    steps.push({
      title: ACCEPT_LOAN.TITLE,
      content: text,
      description: text,
      key: StatusStep.ACCEPT_LOAN_CONTRACT,
    });
  }

  return steps;
};

export const getStepIndexByKey = (key: StatusStep, steps: Steps): number => {
  return steps.findIndex((step: StepType) => step.key === key);
};
